import './index.scss';

import { Component, ReactNode } from 'react';

export type BraxAlertBarProps = {
    open: boolean,
    children: ReactNode
};

export class BraxAlertBar extends Component<BraxAlertBarProps> {

    static defaultProps = {
        open: false
    };

    render() {
        return (
            <div className={`brax-alert-bar ${this.props.open ? 'open' : ''}`}>
                { this.props.children }
            </div>
        );
    }

}
